import Proj11 from "../assets/fincart.png";
import Proj14 from "../assets/viraniproject.png";
import Proj2 from "../assets/eekifood.png";
import Proj3 from "../assets/globalhunt.png";
import Proj4 from "../assets/virani_customer.png";
import Proj5 from "../assets/sso.jpeg";
import Proj6 from "../assets/ecm.jpeg";
import Proj7 from "../assets/cbt.jpeg";
import Proj8 from "../assets/edc.jpeg";
import Proj9 from "../assets/pre-exam.jpeg";
export const ProjectList = [
  {
    name: "Fincart",
    image: Proj11,
    skills: "Nextjs, CSS, Bootstrap",
  },
  {
    name: "Eekifood",
    image: Proj2,
    skills: "Nextjs, CSS, Bootstrap",
  },

  {
    name: "Globalalhunt",
    image: Proj3,
    skills: "Html, CSS, Bootstrap, jquery",
  },
  {
    name: "Virani admin Dashboard",
    image: Proj14,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
  {
    name: "Virani customer Dashboard",
    image: Proj4,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
  {
    name: "Single Sign On (SSO)",
    image: Proj5,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
  {
    name: "Electronic Content Management (ECM)",
    image: Proj6,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
  {
    name: "Computer Based Test (CBT)",
    image: Proj7,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },

  {
    name: "Exam Data Center (EDC)",
    image: Proj8,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
  {
    name: "Pre-Examination",
    image: Proj9,
    skills:
      "ReactJs, Redux Toolkit, JavaScript, HTML, CSS, Tailwind CSS, MaterialUi",
  },
];
